import React from 'react'
import "./Avatar.css"

function RemovePopUp({ setViewPopup, setAvatarOnlyName, setSelectedAvatar, handleSave, setRemoveAvatar, handleProfileClose }) {

    const handleRemoveAvatar = () => {
        setSelectedAvatar(null);
        setAvatarOnlyName("");
        setViewPopup(false);
        handleSave()
        setRemoveAvatar(false)
    };
    return (
        <div className=" successful_create_transprant_body">
            <div className=" p-2 successful_create_container shadow">
                <div>
                    <span className=" mb-5 successfully_create_message">
                        {`Are you sure you want to remove the avatar?`}
                    </span>
                </div>
                <div className='d-flex justify-content-evenly w-100'>
                    <div>
                        <button
                            onClick={handleRemoveAvatar}

                            className="px-4 py-2 mybtn"
                        >
                            Yes

                        </button>
                    </div>
                    <div>
                        <button
                            onClick={() => {
                                setViewPopup(false)
                            }}
                            className="btn btn-danger px-4 py-2 successfull_create_okay_btn"
                        >
                            No

                        </button>
                    </div>

                </div>
            </div>
        </div >
    )
}

export default RemovePopUp